import { useEffect, useState } from "react";
import { withRouter, useParams, RouteComponentProps } from "react-router";
import { IonContent, IonPage, IonButton, IonInput, IonItem, IonTextarea, useIonToast } from "@ionic/react";
import { IOpinionClienteFiscalizacion, IPostComentarioFiscalizacion, fetchOpinionCliente, postComentarioFiscalizacion, postOpinionClienteFiscalizacion } from "src/services/Fiscalizacion/Fiscalizacion";

import Header from "src/components/Header";
import PanelFiscalizacion from "src/components/Fiscalizacion/PanelFiscalizacion";
import "./Fiscalizacion.css";
import { useFiscalizacion } from "src/components/Fiscalizacion/FiscalizacionContext";

interface Params {
    fis_id: string;
    nombre: string;
    codigo: string;
    objetivo: string;
    ps_id: string;
    cod_id: string;
  }


const FiscalizarOpinion = ({ history }:RouteComponentProps) => {
    const {setInformacionFiscalizacionOpinion} = useFiscalizacion();
    const { ps_id, nombre, codigo,fis_id, objetivo } = useParams<Params>();
    const TIPO_COMENTARIO_OPINION = "1";

    const [opinion, setOpinion] = useState({ nombre_contacto: '', opinion_cliente: '' });
    const [comentariosExistentes, setComentariosExistentes] = useState<IOpinionClienteFiscalizacion[]>([]);

    const [errorMessagePresent, setErrorMessagePresent] = useState<string | undefined | null>(undefined);

    const [present] = useIonToast();

    useEffect(() => {
        const obtenerOpinion = async () => {
            try {
                const resultado = await fetchOpinionCliente(parseInt(fis_id));
                if (resultado.error) {
                    setErrorMessagePresent(resultado.error);
                    console.error('Error al obtener la opinion:', resultado.error);
                } else {
                    setComentariosExistentes([resultado.datos]);
                    setErrorMessagePresent(null); // Limpiar mensaje de error en caso de éxito
                }
            } catch (error:any) {
                setErrorMessagePresent(error.info);
                console.error('ERROR:', error);
            }
        };

        obtenerOpinion();
    }, [fis_id]);


    useEffect(() => {
        if (errorMessagePresent) {
            present(errorMessagePresent, 6000);
            setErrorMessagePresent(undefined);
        }
    }, [errorMessagePresent, present]);

    const guardarOpinion = async () => {
        // Validar si el comentario está vacío
        if (!opinion.opinion_cliente || !opinion.opinion_cliente.trim()) {
            present('Por favor, ingrese un comentario antes de guardar.', 6000);
            return;
        }

        // Validar si el nombre de contacto está vacío
        if (!opinion.nombre_contacto || !opinion.nombre_contacto.trim()) {
            present('Por favor, ingrese un nombre de contacto antes de guardar.', 6000);
            return;
        }
        
        const comentarioData: IPostComentarioFiscalizacion = {
            comentario: opinion.opinion_cliente,
            contacto: opinion.nombre_contacto,
            cod_id: TIPO_COMENTARIO_OPINION,
            comentario_id: comentariosExistentes.length > 0 ? comentariosExistentes[0]?.id : undefined, // Enviar comentario_id si existe
        };
        
        setInformacionFiscalizacionOpinion(comentarioData)
    
        const resultado = await postOpinionClienteFiscalizacion(comentarioData, fis_id,);
        if (resultado.exito) {
            present('Comentario guardado con éxito', 6000);
            history.goBack()

        } else {
            const mensajeError = resultado.info || 'Ocurrió un error al guardar el comentario. Por favor, inténtelo de nuevo.';
            present(mensajeError, 6000);
        }

    };

    return (
        <IonPage>
            <Header titulo="Fiscalización - Opinion del Cliente" />

            <IonContent id="fiscalizacion">
            <div className="fisContainer">
                <PanelFiscalizacion />
                <div className="fisCard">
                    <div className="fisCard_title--area">
                        <img src="assets/icon/fisc-COD5.svg" alt="Opinion del Cliente" />
                        <h1>Opinion del Cliente</h1>
                    </div>
                    <IonItem>
                        <IonInput
                            clearInput={true}
                            placeholder="Ingrese el nombre del contacto"
                            value={opinion.nombre_contacto || ''}
                            onIonChange={(e) => setOpinion({...opinion, nombre_contacto: e.detail.value || ''})}
                        ></IonInput>
                    </IonItem>
                    <IonItem>
                        <IonTextarea
                            placeholder="Ingrese su comentario aquí"
                            value={opinion.opinion_cliente || ''}
                            onIonChange={(e) => setOpinion({...opinion, opinion_cliente: e.detail.value || ''})}
                        ></IonTextarea>
                    </IonItem>
                    <IonButton onClick={guardarOpinion}>Guardar Opinion del Cliente</IonButton>
                </div>
                {comentariosExistentes.map((item, index) => (
                    <div className="comentarios" key={index}>
                    <div className="fisCard">
                        <div className="fisCard_title--area">
                            <h4>Nombre:</h4>
                            <p>{item.nombre_contacto}</p>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div>
                                <h4>Comentario:</h4>
                                <p>{item.opinion_cliente}</p>
                            </div>
                        </div>
                        <hr />
                        </div>
                    </div>
                ))}
            </div>
            </IonContent>
        </IonPage>
    );
};

export default withRouter(FiscalizarOpinion);
